import { User } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const UserIcon = createLucideIcon(User);
